
import APIClass = require("./app"); // for typings only
import RhythmGIS = require("./applications/rhythm-gis-app"); // for typings only
import Utils = require("./utils");
import Portal = require("portal-gis"); // for typings only

// app loader uses the api to get application configuration before instantiating the application
// amd package definitions are updated before the application loads
// controls and commands are registered with the application once it is 'ready' to do so
class Runner {

    static about = `
App loader uses the api to get application configuration before instantiating the application.
AMD package definitions are updated before the application loads.
Controls and commands are registered with the application once it is 'ready' to do so.
    `;

    static run(api: APIClass, options: {
        controller: (config: Portal.MapApplicationElement) => RhythmGIS
        appid: string
    }) {

        api.getAppInfo(Utils.split(options.appid)).done(appInfo => {

            appInfo = Utils.deep(api.defaults(appInfo));

            // todo: how to handle i18n?  want to mixin configuration with i18n modules.
            // todo: how can layer factories get to configuration information?
            Utils.options = Utils.asDictionary(appInfo.Options.Values);

            api.mergePackages(appInfo.Packages);
            api.controller = options.controller(appInfo);

            api.run();

        });
    }
}

export = Runner;